(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var dropdowns = document.querySelectorAll('.nav-dropdown');
    var timers = new WeakMap();

    function openDropdown(dd) {
      var btn = dd.querySelector('.nav-dropdown-label');
      clearTimeout(timers.get(dd));
      dropdowns.forEach(function(d) {
        if (d !== dd) closeDropdown(d, 0);
      });
      dd.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown(dd, delay) {
      var btn = dd.querySelector('.nav-dropdown-label');
      clearTimeout(timers.get(dd));
      if (delay) {
        timers.set(dd, setTimeout(function() {
          dd.classList.remove('is-open');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }, delay));
      } else {
        dd.classList.remove('is-open');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    }

    dropdowns.forEach(function(dropdown) {
      var button = dropdown.querySelector('.nav-dropdown-label');
      if (!button) return;

      // Click toggle (keyboard / touch)
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = dropdown.classList.contains('is-open');
        dropdowns.forEach(function(d) { closeDropdown(d, 0); });
        if (!isOpen) openDropdown(dropdown);
      });

      // On mobile, the page-link in split dropdowns toggles instead of navigating
      var pageLink = dropdown.querySelector('.nav-dropdown-page-link');
      if (pageLink) {
        pageLink.addEventListener('click', function(e) {
          if (window.innerWidth <= 768) {
            e.preventDefault();
            e.stopPropagation();
            var isOpen = dropdown.classList.contains('is-open');
            dropdowns.forEach(function(d) { closeDropdown(d, 0); });
            if (!isOpen) openDropdown(dropdown);
          }
        });
      }

      // Hover open/close — only on true pointer devices, not touch
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        dropdown.addEventListener('mouseenter', function() {
          openDropdown(dropdown);
        });
        dropdown.addEventListener('mouseleave', function() {
          closeDropdown(dropdown, 200);
        });
      }

      dropdown.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          closeDropdown(dropdown, 0);
          button.focus();
        }
      });
    });

    document.addEventListener('click', function() {
      dropdowns.forEach(function(d) { closeDropdown(d, 0); });
    });

    var hamburger = document.querySelector('.nav-hamburger');
    var navLinks  = document.getElementById('primary-nav');
    if (hamburger && navLinks) {
      hamburger.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = navLinks.classList.contains('is-open');
        navLinks.classList.toggle('is-open', !isOpen);
        hamburger.setAttribute('aria-expanded', String(!isOpen));
        hamburger.classList.toggle('is-active', !isOpen);
      });
      document.addEventListener('click', function(e) {
        if (!navLinks.contains(e.target) && e.target !== hamburger) {
          navLinks.classList.remove('is-open');
          hamburger.setAttribute('aria-expanded', 'false');
          hamburger.classList.remove('is-active');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-features"] && !Shopify.designMode) return;
  try {
    
(function() {
  var tabs = document.querySelectorAll('.feat-tab');
  var sectionIds = ['collect', 'manage', 'display', 'operate'];
  var sections = sectionIds.map(function(id) { return document.getElementById(id); });

  function onScroll() {
    var scrollY = window.scrollY + 120;
    var active = null;
    sections.forEach(function(sec) {
      if (sec && sec.offsetTop <= scrollY) active = sec.id;
    });
    tabs.forEach(function(tab) {
      var href = tab.getAttribute('href').replace('#', '');
      tab.classList.toggle('feat-tab--active', href === active);
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-home-hero"] && !Shopify.designMode) return;
  try {
    
// Hero tab bar + sidebar sub-panel switching
(function() {
  var tabbar    = document.getElementById('hero-tabbar');
  var dashboard = document.getElementById('hero-panel-dashboard');
  var insights  = document.getElementById('hero-panel-ai-insights');
  var search    = document.getElementById('hero-panel-ai-search');
  if (!tabbar) return;

  // Main tab switching (Dashboard / AI Insights / AI Search)
  var mainPanels = { dashboard: dashboard, 'ai-insights': insights, 'ai-search': search };
  tabbar.querySelectorAll('.cm-ai-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var panel = tab.getAttribute('data-panel');
      tabbar.querySelectorAll('.cm-ai-tab').forEach(function(t) {
        t.classList.remove('cm-ai-tab--active');
      });
      tab.classList.add('cm-ai-tab--active');
      Object.keys(mainPanels).forEach(function(key) {
        mainPanels[key].style.display = key === panel ? '' : 'none';
      });
    });
  });

  // Sidebar nav switching (Overview / Inbox / Analytics)
  var sidebarNav = document.getElementById('hero-sidebar-nav');
  var overview   = document.getElementById('hero-subpanel-overview');
  var inbox      = document.getElementById('hero-subpanel-inbox');
  var analytics  = document.getElementById('hero-subpanel-analytics');
  if (!sidebarNav) return;
  var subPanels = { overview: overview, inbox: inbox, analytics: analytics };
  sidebarNav.querySelectorAll('[data-subpanel]').forEach(function(item) {
    item.addEventListener('click', function() {
      var sp = item.getAttribute('data-subpanel');
      sidebarNav.querySelectorAll('[data-subpanel]').forEach(function(i) {
        i.classList.remove('cm-db-nav-item--active');
      });
      item.classList.add('cm-db-nav-item--active');
      Object.keys(subPanels).forEach(function(key) {
        if (subPanels[key]) subPanels[key].style.display = key === sp ? '' : 'none';
      });
    });
  });

  // ── Clickability hint animation ──────────────────────────
  // Sweeps non-active tabs then sidebar items so users know
  // they can click. Fires at 2s then repeats once at 7s.
  function runHint() {
    // Tab bar: hint each non-active tab in sequence
    var inactiveTabs = Array.from(
      tabbar.querySelectorAll('.cm-ai-tab:not(.cm-ai-tab--active)')
    );
    inactiveTabs.forEach(function(tab, i) {
      setTimeout(function() {
        tab.classList.add('cm-ai-tab--hint');
        setTimeout(function() {
          tab.classList.remove('cm-ai-tab--hint');
        }, 900);
      }, i * 650);
    });
    // Sidebar nav items: hint non-active items, offset after tabs
    var inactiveNavItems = Array.from(
      sidebarNav.querySelectorAll('[data-subpanel]:not(.cm-db-nav-item--active)')
    );
    inactiveNavItems.forEach(function(item, i) {
      setTimeout(function() {
        item.classList.add('cm-db-nav-item--hint');
        setTimeout(function() {
          item.classList.remove('cm-db-nav-item--hint');
        }, 850);
      }, 400 + i * 600);
    });
  }

  setTimeout(runHint, 2000);
  setTimeout(runHint, 8500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-pricing-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btnMonthly = document.getElementById('rc-btn-monthly');
    var btnAnnual = document.getElementById('rc-btn-annual');
    if (!btnMonthly || !btnAnnual) return;
    var amounts = document.querySelectorAll('.tier-card-amount[data-monthly]');

    function setMonthly() {
      btnMonthly.classList.add('billing-btn--active');
      btnMonthly.setAttribute('aria-pressed', 'true');
      btnAnnual.classList.remove('billing-btn--active');
      btnAnnual.setAttribute('aria-pressed', 'false');
      amounts.forEach(function(el) {
        el.textContent = '$' + el.dataset.monthly;
      });
    }

    function setAnnual() {
      btnAnnual.classList.add('billing-btn--active');
      btnAnnual.setAttribute('aria-pressed', 'true');
      btnMonthly.classList.remove('billing-btn--active');
      btnMonthly.setAttribute('aria-pressed', 'false');
      amounts.forEach(function(el) {
        el.textContent = '$' + el.dataset.annual;
      });
    }

    btnMonthly.addEventListener('click', setMonthly);
    btnAnnual.addEventListener('click', setAnnual);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.getElementById('rc-testimonials-{{ section.id }}');
    if (!section) return;

    var track = section.querySelector('.testimonials-track');
    var prevBtn = section.querySelector('.testi-prev');
    var nextBtn = section.querySelector('.testi-next');
    if (!track) return;

    function scrollAmount() {
      var card = track.querySelector('.testimonial-card');
      if (!card) return 320;
      var gap = parseFloat(getComputedStyle(track).gap) || 20;
      return card.offsetWidth + gap;
    }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-vertical-hero-interactive"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-vhi]').forEach(function(el) {
    if (!el.classList.contains('vhi-list-item')) return;
    el.addEventListener('click', function() {
      var sid = el.getAttribute('data-vhi');
      var idx = el.getAttribute('data-idx');
      var listEl = document.getElementById('vhi-list-' + sid);
      var expandedEl = document.getElementById('vhi-expanded-' + sid);
      if (!listEl || !expandedEl) return;
      listEl.querySelectorAll('.vhi-list-item').forEach(function(i) {
        i.classList.remove('vhi-list-item--active', 'vhi-list-item--unread');
      });
      el.classList.add('vhi-list-item--active');
      expandedEl.querySelectorAll('.vhi-panel').forEach(function(p) {
        p.classList.remove('vhi-panel--active');
      });
      var target = expandedEl.querySelector('.vhi-panel[data-idx="' + idx + '"]');
      if (target) target.classList.add('vhi-panel--active');
    });
  });

  document.querySelectorAll('.vhi-list').forEach(function(listEl) {
    var sid = listEl.id.replace('vhi-list-', '');
    var items = listEl.querySelectorAll('.vhi-list-item');
    if (items.length < 2) return;
    var hinted = 0;
    function hint() {
      hinted = (hinted + 1) % items.length;
      items.forEach(function(i) { i.classList.remove('vhi-list-item--hint'); });
      if (!items[hinted].classList.contains('vhi-list-item--active')) {
        items[hinted].classList.add('vhi-list-item--hint');
        setTimeout(function() { items[hinted].classList.remove('vhi-list-item--hint'); }, 800);
      }
    }
    setTimeout(hint, 1800);
    setTimeout(hint, 4200);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
